import React from 'react';

import { Box, Paper, Typography } from '@mui/material';

interface RelatedTileField {
  label: string;
  value: React.ReactNode;
}

interface Props {
  fields: ReadonlyArray<RelatedTileField>;
  heading: React.ReactNode;
}

export default function RelatedTile({ fields, heading }: Props) {
  return (
    <Paper variant="outlined" sx={{ p: 2 }}>
      {heading}
      <Box
        component="dl"
        sx={{ display: 'grid', gridTemplateColumns: 'auto 1fr', columnGap: 1, rowGap: 0.5, mt: 1, mb: 0 }}
      >
        {fields.map(({ label, value }) => (
          <React.Fragment key={label}>
            <Typography component="dt" variant="body2" color="text.secondary">
              {label}:
            </Typography>
            <Typography component="dd" variant="body2" sx={{ m: 0, overflowWrap: 'anywhere' }}>
              {value || '—'}
            </Typography>
          </React.Fragment>
        ))}
      </Box>
    </Paper>
  );
}
